import { I as Icon, d as defineCustomElement$1 } from './icon.js';

const TtIcon = Icon;
const defineCustomElement = defineCustomElement$1;

export { TtIcon, defineCustomElement };
